import api from 'api';
import { useEffect, useState } from 'react';
import styles from '../../assessmentPage/Questionnaire/GeneralInfo.module.scss';
import cn from 'classnames';

interface CompanyForm {
    email: string;
    company_name: string;
    legal_entity_name: string;
    incorporated: boolean;
    country: string;
    region: string;
    address: string;
    city: string;
    zip_code: string;
    vat_number: string;
    phone_number: string;
    short_description: string;
    long_description: string;
}

const initCompanyForm: CompanyForm = {
    email: '',
    company_name: '',
    legal_entity_name: '',
    incorporated: false,
    country: '',
    region: '',
    address: '',
    city: '',
    zip_code: '',
    vat_number: '',
    phone_number: '',
    short_description: '',
    long_description: '',
};

interface Expertise {
    expertise_name: string;
    expertise_level: string;
}
export default function CompanyInfo() {
    const serviceProviderTableName = 'ServiceProvider';
    const expertiseTableName = 'Expertise';

    const [form, setForm] = useState<CompanyForm>(initCompanyForm);
    const [, setExpertiseForm] = useState<Expertise[]>([]);

    useEffect(() => {
        api.tableInput.newFetchCandidateInput(setForm, serviceProviderTableName);
        api.tableInput.newFetchCandidateInput(setExpertiseForm, expertiseTableName);
    }, []);

    return (
        <>
            <div>
                <span>
                    <h4 className={styles.title}>Company</h4>{' '}
                    <div className={` ${cn(styles.box, styles.fullWidth)}`}>
                        <div className={`grid grid-cols-2 gap-x-5`}>
                            <h4>Company Name</h4>
                            <h4>Company Legal Name</h4>

                            <p className={styles.value}>{form?.company_name} </p>
                            <p className={styles.value}> {form?.legal_entity_name}</p>

                            <h4>Phone Number</h4>
                            <h4>Email</h4>
                            <p className={styles.value}> {form?.phone_number}</p>
                            <p className={styles.value}>{form?.email} </p>

                            <h4>Country</h4>
                            <h4>Region</h4>
                            <p className={styles.value}> {form?.country}</p>
                            <p className={styles.value}> {form?.region}</p>
                            <h4>City</h4>
                            <h4>Incorporated</h4>
                            <p className={styles.value}> {form?.city}</p>
                            <p className={styles.value}> {form?.incorporated ? 'Yes' : 'No'}</p>
                            <h4>Zip</h4>
                            <h4>Vat</h4>

                            <p className={styles.value}> {form?.zip_code}</p>
                            <p className={styles.value}> {form?.vat_number}</p>
                        </div>
                        <h4>Short Description</h4>

                        <p className={styles.value}> {form?.short_description}</p>
                        <h4>Long Description</h4>

                        <p className={styles.value}> {form?.long_description}</p>
                    </div>
                </span>
            </div>
        </>
    );
}
